export default {
  'entities.list.title': 'Entities',
  'entities.admin.title': 'Manage Entities',
  'entities.group.title': 'Add Entity Group',

  // ────────────────────────────────────────────────────────────────────
  // Modern manage entity view (`/entities/:id`)
  // ────────────────────────────────────────────────────────────────────
  'manage.entities.modern.refresh': 'Refresh',
  'manage.entities.modern.configure': 'Configure',
  'manage.entities.modern.tagline.fallback': 'View, filter and manage the records of this entity.',
  'manage.entities.modern.filters.toggle': 'Filters',
  'manage.entities.modern.empty.title': 'No records',
  'manage.entities.modern.empty.description':
    'We could not find records matching the current filters. Adjust your filters or create a new record.',

  'entities.form.title': 'Add Entity',
  'entities.button.open': 'Open',
  'entities.button.builder': 'Configure entity',
  'entities.form.displayName': 'Name to Display',
  'entities.form.displayPluralName': 'Plural Name',
  'entities.form.description': 'Description',
  'entities.form.order': 'Order',
  'entities.form.type': 'Type',
  'entities.form.enabled': 'Enabled Element?',
  'entities.form.externalViewEnabled': 'External View Enabled?',
  'entities.form.entityGroup': 'Entity Group',

  'entity.prop.displayName': 'Name',
  'entity.prop.isRequired': 'Status',
  'entity.prop.order': 'Order',
  'entity.prop.type': 'Type',
  'entity.prop.options': 'Options',
  'entity.prop.name': 'Name',
  'entity.prop.token': 'Token',
  'entity.prop.permission': 'Permission',
  'entity.prop.status': 'Status',
  'entity.prop.description': 'Description',
  'entity.prop.user': 'User',
  'entity.prop.entityType': 'Type',
  'entity.prop.dynamicEntityVersionNumber': 'Version',
  'entity.prop.itemType': 'Item Type',
  'entity.prop.itemName': 'Item Name',
  'entity.prop.itemPropertyDisplay': 'Item Property',
  'entity.prop.fieldDestinationDisplay': 'Field Destination',
  'entity.prop.destinationReferenceDisplay': 'Destination Reference',
  'entity.prop.destinationDynamicEntityDisplay': 'Destination Entity',
  'entity.prop.destinationDynamicEntityVersionNumber': 'Destination Version',
  'entity.prop.internalName': 'Internal Name',
  'entity.prop.created': 'Created',
  'entity.prop.versionNumber': 'Version Number',
  'entity.prop.operation': 'Operation',
  'entity.prop.creator': 'Creator',
  'entity.prop.data': 'Data',
  'entity.prop.number': 'Number',
  'entity.prop.operationType': 'Operation Type',
  'entity.prop.importance': 'Importance',
  'entity.prop.scheduledDate': 'Scheduled Date',
  'entity.prop.observations': 'Observations',

  'entity.tab.configuration': 'Edit Entity - {name}',
  'entity.tab.configurations': 'Configurations',
  'entity.tab.fields': 'Fields',
  'entity.tab.relations': 'Relations',
  'entity.tab.tokens': 'Tokens',
  'entity.tab.lists': 'Lists',
  'entity.tab.contributors': 'Contributors',
  'entity.tab.dependencies': 'Dependencies',
  'entity.tab.dependents': 'Dependents',
  'entity.tab.traces': 'Traces',
  'entity.tab.tasks': 'Tasks',
  'entity.tab.options': 'Options',

  'entity.accessMode1': 'Read',
  'entity.accessMode2': 'Write',

  'entity.text.showEntity': 'Show Entity',
  'entities.text.dynamicEntityGroups': 'Dynamic Entity Groups',

  'entity.field.text': 'Text',
  'entity.field.textMultiple': 'MultipleText',
  'entity.field.int': 'Integer',
  'entity.field.decimal': 'Decimal Number',
  'entity.field.boolean': 'Yes / No',
  'entity.field.date': 'Date',
  'entity.field.dateTime': 'Date Time',
  'entity.field.datetime': 'Date and time',
  'entity.field.time': 'Time',
  'entity.field.choice': 'Choice',
  'entity.field.dataBaseRemoteSearch': ' Remote Search - Database',
  'entity.field.dataBaseRemoteList': 'Remote List - Database',
  'entity.field.webServiceRemoteSearch': 'Remote Search - Web Service',
  'entity.field.webServiceRemoteList': 'Remote List - Web Service',
  'entity.field.fieldDynamicEntityList': 'List - Dynamic Entity',
  'entity.field.selectorUser': 'User Selector',
  'entity.field.selectorPosition': 'Selector Position',
  'entity.field.selectorUserGroup': 'Selector User Groups',
  'entity.field.table': 'Table',
  'entity.field.attachment': 'Attachment',
  'entity.field.areaSelector': 'Area Selector',
  'entity.field.autoCalculatedByTableColumn': 'AutoCalculatedByTableColumn',
  'entity.field.fieldDynamicEntity': 'DynamicEntityField',
  'entity.field.calculatedByFormula': 'Calculated by formula',
  'entity.field.image': 'Image',
  'entity.field.photo': 'Photo',
  'entity.field.signature': 'Signature',
  'entity.field.goToAction': 'Action',
  'entity.field.slider': 'Slider',
  'entity.field.selectorArea': 'Area Selector',
  'entity.field.radioGroup': 'Radio Group',
  'entity.field.checkGroup': 'Check Group',
  'entity.field.url': 'URL',
  'entity.field.email': 'Email',
  'entity.field.location': 'Location',
  'entity.field.password': 'Password',
  'entity.field.fieldDynamicEntitySearch': 'Search - Dynamic Entity',
  'entity.field.likertScale': 'Likert Scale',

  'entity.field.status.required': 'Required',
  'entity.field.status.notRequired': 'Not Required',

  'entity.attr.allowedExtensions': 'Allowed Extensions',
  'entity.attr.allowInsertNewOption': 'Allow Insert New Option?',
  'entity.attr.allowMultiple': 'Allow Multiple?',
  'entity.attr.questions': 'Questions',
  'entity.attr.responses': 'Responses',
  'entity.attr.minTableLines': 'Min rows',
  'entity.attr.maxTableLines': 'Max rows',
  'entity.attr.sortMode': 'Default sort',
  'entity.attr.sortMode.lastAddedFirst': 'Last added first',
  'entity.attr.sortMode.lastAddedLast': 'Last added last',
  'entity.attr.confirmationQuestion': 'Confirmation question',
  'entity.attr.autoSelect': 'Auto-select?',
  'entity.attr.autoSelectAll': 'Auto Select All',
  'entity.attr.choices': 'Options',
  'entity.attr.codeProperty': 'Code Property',
  'entity.attr.columnWidth': 'Column Width',
  'entity.attr.connection': 'Connection',
  'entity.attr.currentDateDefaultValueEnabled': 'Current Date Default Value Enabled',
  'entity.attr.currentDateTimeDefaultValueEnabled': 'Current Date Time Default Value Enabled',
  'entity.attr.currentTimeDefaultValueEnabled': 'Current Time Default Value Enabled',
  'entity.attr.currentUser': 'Default Current User',
  'entity.attr.currentUserArea': 'Current User Area',
  'entity.attr.currentUserPosition': 'Default Current User Position',
  'entity.attr.currentUserUserGroups': 'Default Current User Groups',
  'entity.attr.databaseQueryId': 'Query',
  'entity.attr.decimalPlaces': 'Decimal Places',
  'entity.attr.defaultValue': 'DefaultValue',
  'entity.attr.destinationFolder': 'Destination Folder',
  'entity.attr.destinationFolderId': 'Destination Folder',
  'entity.attr.displayText': 'Display Text',
  'entity.attr.displayTextDynamicEntityField': 'Display Text Field',
  'entity.attr.displayTextProperty': 'Display Text Property',
  'entity.attr.dynamicEntity': 'Dynamic Entity',
  'entity.attr.dynamicEntityId': 'Dynamic Entity',
  'entity.attr.enabled': 'Enabled',
  'entity.attr.extraLarge': 'Extra Large',
  'entity.attr.filters': 'Filters',
  'entity.attr.format': 'Format',
  'entity.attr.formula': 'Formula',
  'entity.attr.groupingType': 'Grouping Type',
  'entity.attr.id': 'ID',
  'entity.attr.internalName': 'Internal Name',
  'entity.attr.isActive': 'Element Enabled?',
  'entity.attr.isCurrentDateDefaultValue': 'CurrentDateDefault?',
  'entity.attr.isCurrentTimeDefaultValue': 'Default Current Time?',
  'entity.attr.isCurrentUserLocationEnabled': 'Enable Current User Location?',
  'entity.attr.isMaxIntValueEnabled': 'Enable Maximum Value Control?',
  'entity.attr.isMaxLengthEnabled': 'Enable MaxLength?',
  'entity.attr.isMaxSelectionsAllowed': 'Enable Maximum Selections Control?',
  'entity.attr.isMaxSelectionsAllowedEnabled': 'Enable Maximum Selections Control?',
  'entity.attr.isMinIntValueEnabled': 'Enable Minimum Value Control?',
  'entity.attr.isMinSelectionsRequired': 'Enable Minimum Selections Control?',
  'entity.attr.isMinSelectionsRequiredEnabled': 'Enable Minimum Selections Control?',
  'entity.attr.isRegularExpressionValidationEnabled': 'Enable Regular Expression Validation?',
  'entity.attr.isRequired': 'Required?',
  'entity.attr.isUniqueValueValidationEnabled': 'Unique Value Validation Enabled?',
  'entity.attr.isVisibleInManagementTable': 'Visible in Management Table?',
  'entity.attr.visibleInManagement': 'Visible in Management Table?',
  'entity.attr.isVisibleInDetails': 'Visible in Details?',
  'entity.attr.key': 'Key',
  'entity.attr.large': 'Large',
  'entity.attr.maxAttachmentsAllowed': 'Max Attachments Allowed',
  'entity.attr.maxDecimalValue': 'Number of Decimal Places Allowed',
  'entity.attr.maxFileSize': 'Max File Size',
  'entity.attr.maxHeightRequired': 'Max Height Required',
  'entity.attr.maxIntValue': 'Maximum Value',
  'entity.attr.maxLength': 'MaximumLength',
  'entity.attr.maxSelectionsAllowed': 'Maximum Selections Allowed',
  'entity.attr.maxValue': 'Max Value',
  'entity.attr.maxValueFieldId': 'Max Value Field',
  'entity.attr.maxWidthRequired': 'Max Width Required',
  'entity.attr.medium': 'Medium',
  'entity.attr.minAttachmentsRequired': 'Min Attachments Required',
  'entity.attr.minHeightRequired': 'Min Height Required',
  'entity.attr.minIntValue': 'Minimum Value',
  'entity.attr.minLength': 'MinimumLength',
  'entity.attr.minValue': 'Min Value',
  'entity.attr.minSelectionsRequired': 'Minimum Selections Required',
  'entity.attr.minValueFieldId': 'Min Value Field',
  'entity.attr.minWidthRequired': 'Min Width Required',
  'entity.attr.modifier': 'Modifier',
  'entity.attr.observations': 'Observations',
  'entity.attr.order': 'Order',
  'entity.attr.orderByDynamicEntityField': 'Order By Field',
  'entity.attr.orderDirection': 'Order Direction',
  'entity.attr.regularExpression': 'Regular Expression',
  'entity.attr.relatedDynamicEntityFieldId': 'Related Field',
  'entity.attr.relatedDynamicEntityFieldValueId': 'Related FieldValue',
  'entity.attr.relatedDynamicEntityId': 'Related Dynamic Entity',
  'entity.attr.required': 'Required',
  'entity.attr.scannerEnabled': 'Scanner Enabled?',
  'entity.attr.searchParameterName': 'Search Parameter Name',
  'entity.attr.searchValueProperty': 'Search Value Property',
  'entity.attr.small': 'Small',
  'entity.attr.textFormat': 'Text Format',
  'entity.attr.type': 'Type',
  'entity.attr.updated': 'Updated',
  'entity.attr.userDisplayValue': 'User Display Value',
  'entity.attr.userExtraField': 'User Extra Field',
  'entity.attr.valueDynamicEntityField': 'Value Field',
  'entity.attr.webApiConnectionId': 'API Connection',
  'entity.attr.visibleInDetails': 'Visible in Details',
  'entity.attr.creator': 'Creator',
  'entity.attr.created': 'Created',
  'entity.attr.minValueField': 'Min Value Field',
  'entity.attr.maxValueField': 'Max Value Field',
  'entity.attr.userCreator': 'User Creator',
  'entity.attr.userModifier': 'User Modifier',
  'entity.attr.step': 'Step',

  'entity.extension.jpg': 'JPG Image',
  'entity.extension.jpeg': 'JPEG Image',
  'entity.extension.png': 'PNG Image',
  'entity.extension.gif': 'GIF Image',
  'entity.extension.bmp': 'BMP Image',
  'entity.extension.svg': 'SVG Image',
  'entity.extension.webp': 'WebP Image',
  'entity.extension.ico': 'ICO Icon',
  'entity.extension.tiff': 'TIFF Image',
  'entity.extension.tif': 'TIF Image',
  'entity.extension.pdf': 'PDF Document',
  'entity.extension.doc': 'Word Document',
  'entity.extension.docx': 'Word Document (DOCX)',
  'entity.extension.xls': 'Excel Spreadsheet',
  'entity.extension.xlsx': 'Excel Spreadsheet (XLSX)',
  'entity.extension.txt': 'Text File',
  'entity.extension.csv': 'CSV File',

  'entity.token.name': 'Name',
  'entity.token.add': 'Add Token',
  'entity.token.detail': 'Token Detail',
  'entity.token.isReadEnabled': 'Read Enabled?',
  'entity.token.isWriteEnabled': 'Write Enabled?',
  'entity.token.isDeleteEnabled': 'Delete Enabled?',
  'entity.token.isActive': 'Enabled Element?',
  'entity.token.read': 'Read',
  'entity.token.write': 'Write',
  'entity.token.delete': 'Delete',
  'entity.token.url': 'Documentation',

  'entity.list.add': 'Add List',
  'entity.list.edit': 'Edit List',
  'entity.list.detail': 'List Detail',
  'entity.list.group': 'List Group',
  'entity.list.type': 'Type',
  'entity.list.formMode': 'Edit Mode',
  'entity.list.type.taskBoard': 'Task Board',
  'entity.list.type.cardsList': 'Cards List',
  'entity.list.type.mapList': 'Map List',

  'dynamicEntities.title': 'Manage - {name}',
  'dynamicEntities.userGroup': 'User Group',
  'dynamicEntities.userGroupExists': 'User Group Exists',
  'dynamicEntities.title.detail': 'Details',

  'dynamicEntities.form.email': 'Email',
  'dynamicEntities.form.names': 'Names',
  'dynamicEntities.form.lastNames': 'Last Names',
  'dynamicEntities.form.role': 'Role',
  'dynamicEntities.form.positionId': 'Position',
  'dynamicEntities.form.userBossId': 'Boss',
  'dynamicEntities.form.accessType': 'Access Type',
  'dynamicEntities.form.isActive': 'Enable',

  'dynamicEntities.form.selectGroup': 'Select a Group',
  'dynamicEntities.form.selectUser': 'Select a User',
  'dynamicEntities.mixed': 'Mixed',
  'dynamicEntities.usernameAndPassword': 'User and Password',
  'dynamicEntities.office365': 'Office365',

  'entity.referenceSourceEntityType1': 'Entity',
  'entity.referenceSourceEntityType2': 'Process',
  'entity.referenceSourceEntityType3': 'Custom List',

  'entity.referenceSourceItemType1': 'Entity Field',
  'entity.referenceSourceItemType2': 'Form Field',
  'entity.referenceSourceItemType3': 'Action',
  'entity.referenceSourceItemType4': 'List Field',
  'entity.referenceSourceItemType5': 'Process',

  'entity.purge.confirm.title': 'WARNING!',
  'entity.purge.confirm.body.before':
    'You are about to delete all the entity data. Please note that this operation',
  'entity.purge.confirm.body.emphasis': 'is permanent and irreversible',
  'entity.purge.confirm.body.after': 'and once confirmed, all data will be lost.',
  'entity.purge.confirm.question': 'Are you sure you want to delete all data?',

  'entity.notification.purge.success': 'All entity data has been successfully deleted.',
};
